import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import DynamicTitle from "./DynamicTitle";

function SessionEnd() {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <DynamicTitle>Session Complete</DynamicTitle>
      <Header />

      <main className="flex-grow w-full max-w-lg mx-auto px-4 py-10 sm:py-16">
        <div className="text-center mb-10">
          <div className="text-5xl mb-4" role="img" aria-label="celebration">✨</div>
          <h1 className="text-3xl font-semibold text-gray-900 mb-2">
            Nice work.
          </h1>
          <p className="text-gray-500">
            That's another session in the books.
          </p>
        </div>

        <div className="flex flex-col gap-3 mb-10">
          <Link
            to="/sessions"
            className="w-full bg-accent hover:bg-primary text-white font-semibold py-4 rounded-xl text-center transition"
          >
            Start another session
          </Link>
          <Link
            to="/session-history"
            className="w-full bg-white border border-gray-200 hover:border-gray-400 text-gray-700 font-semibold py-4 rounded-xl text-center transition"
          >
            View your history →
          </Link>
        </div>

        {/* Partner promo slot — drop a card here when there's something to show. */}

        <div className="text-center text-xs text-gray-400 mt-12 space-y-1">
          <p>
            Need to talk to someone? Call or text <strong className="text-gray-500">988</strong>.
          </p>
          <p>
            <Link to="/emergency-support" className="text-gray-500 hover:text-gray-700 underline">
              More support resources
            </Link>
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default SessionEnd;
